import { connect } from 'react-redux';
import { clearUserStatuses, verifyUser } from '../../actions';
import VerifyUser from './component';

export const mapStateToProps = state => (
  {
    registerError: state.user.authError,
    registerSuccess: state.user.authSuccess,
  }
);

export default connect(mapStateToProps, { clearUserStatuses, verifyUser })(VerifyUser);
